import * as React from 'react'

const DefaultNavIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="5zwbeo8dka">
        <stop stopColor="#EFEFEF" offset="0%" />
        <stop stopColor="#C4C4C4" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="jrpsgm4vvb">
        <stop stopColor="#EDF0EF" offset="0%" />
        <stop stopColor="#D1D2D2" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M29 1a28.057 28.057 0 0 1 19.803 8.12C53.867 14.136 57 21.063 57 28.715c0 6.603-4.144 14.708-9.28 21.844C40.933 59.984 32.32 68 29 68c-3.32 0-11.934-8.016-18.72-17.442C5.145 43.422 1 35.318 1 28.714c0-7.652 3.133-14.58 8.197-19.593A28.057 28.057 0 0 1 29 1Z"
        fill="url(#5zwbeo8dka)"
        stroke="url(#jrpsgm4vvb)"
        strokeWidth={2}
        transform="translate(0 -1)"
      />
      <path
        fill="#AEAEAE"
        d="M29.901 14.923a14.33 13.77 0 1 0 0 27.539 14.33 13.77 0 1 0 0-27.539Z"
      />
    </g>
  </svg>
)

export default DefaultNavIcon
